const INTERACTIVE_SELECTOR = [
  'button',
  'a[href]',
  'input',
  'select',
  'textarea',
  '[role="menuitem"]',
  '[role="checkbox"]',
  '[role="switch"]',
  '[role="combobox"]',
  '[role="option"]',
  '[role="menu"]',
  '[role="listbox"]',
  '[data-slot="select-content"]',
  '[data-slot="select-item"]',
  '[data-slot="dropdown-menu-content"]',
  '[data-slot="dropdown-menu-sub-content"]',
  '[data-slot="dialog-content"]',
  '[data-slot="dialog-overlay"]',
  '[data-slot="alert-dialog-content"]',
  '[data-slot="alert-dialog-overlay"]',
  '[data-row-click-ignore]',
].join(',');

/**
 * True when the click landed on (or inside) an interactive element.
 *
 * The element does not have to live inside the row: Radix renders dropdown menus,
 * select options and dialogs in a portal, yet React still bubbles their click up to
 * the row. Requiring `row.contains(...)` would therefore navigate away from the row
 * whenever the user picked an action or a status option.
 */
export function isInteractiveTarget(target: EventTarget | null, row: Element): boolean {
  if (!(target instanceof Element)) return false;
  const interactive = target.closest(INTERACTIVE_SELECTOR);
  return interactive !== null && interactive !== row;
}
